import React, { memo, useState } from 'react';
import classnames from 'classnames';
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react';

import { IconButton } from '../material-ui/IconButton';
import { Left, Right } from '../../icons';
import { useSwiper } from './useSwiper';
import { useStyles } from './useStyles';

import 'swiper/swiper.scss';

export const Swiper = memo(({ slides, slidesPerView, initialSlide, breakpoints, className, wraperClassName }) => {
    const classes = useStyles();
    const [navigate, setNavigate] = useState({});

    const { swiperRef, swiperBreakpoints, handlePrev, handleNext, handleResize, handleSetNavigate } = useSwiper(
        initialSlide,
        slides,
        breakpoints,
        setNavigate
    );

    return (
        <div className={classnames(classes.container, wraperClassName)}>
            <div className={classes.navButton}>
                {navigate.realIndex > 0 && (
                    <IconButton onClick={handlePrev}>
                        <Left width={24} height={24} />
                    </IconButton>
                )}
            </div>
            <ReactSwiper
                className={classnames(classes.swiper, className)}
                threshold={15}
                spaceBetween={10}
                slidesPerView={slidesPerView}
                ref={swiperRef}
                initialSlide={initialSlide}
                onInit={handleSetNavigate}
                onResize={handleResize}
                onSlideChange={handleSetNavigate}
                breakpoints={swiperBreakpoints}
            >
                {slides.map(({ id, Component }, i) => (
                    <SwiperSlide key={`${id}-${i}`} className={classes.slide}>
                        {Component}
                    </SwiperSlide>
                ))}
            </ReactSwiper>
            <div className={classes.navButton}>
                {!navigate.isEnd && (
                    <IconButton onClick={handleNext}>
                        <Right width={24} height={24} />
                    </IconButton>
                )}
            </div>
        </div>
    );
});

Swiper.displayName = 'Swiper';
